import { PageHeader } from "../components/PageHeader";

/** Placeholder until the owning workstream lands its page. */
export function Stub({ title, owner, md }: { title: string; owner: string; md?: { page: string; params?: Record<string, string | number | undefined> } }) {
  return (
    <section data-testid="page-stub">
      <PageHeader title={title} md={md} />
      <p>Coming from {owner}.</p>
    </section>
  );
}
